import { useContext, useEffect } from 'react';
import { GlobalContext } from '../../context/GlobalState';
import { listenCardsChange } from '../../services/cards';

const handleActionItems = (data) => {
  const actionItems = [];
  for (const item of data) {
    actionItems.push(
      typeof item === 'number'
        ? {
            platformActionItemId: item,
            type: 'WORK_ITEM',
          }
        : item
    );
  }
  return { actionItems };
};

function useListenCardsChange() {
  const { currentRetrospectiveId, onUpdateCards } = useContext(GlobalContext);

  useEffect(() => {
    const unsubscribe = listenCardsChange(
      currentRetrospectiveId,
      (querySnapshot) => {
        let cards = [];
        for (const document_ of querySnapshot.docs)
          cards.push({
            ref: document_.ref,
            id: document_.id,
            ...document_.data(),
            ...handleActionItems(document_.data().actionItems),
          });
        cards = cards.sort((card1, card2) =>
          card1.rank < card2.rank ? -1 : 1
        );
        onUpdateCards([...cards]);
      }
    );
    return () => {
      unsubscribe();
    };
  }, [currentRetrospectiveId, onUpdateCards]);
}

export default useListenCardsChange;
